import React, { useEffect } from "react";
import { Spin } from "antd";

import { useHospitalMappingStore } from "@stores/useHospitalMappingStore";

import HospitalListCMService from "@services/hospital-list-and-case-manager.service";

import { tabKeyName } from "../FacilityInfo/FacilityInfo";
import TableComponent from "../table/table";
import Icon from "@assets/icon_config";
import HopitalListAddAndUpdateModal from "../modal/modal";
import "../hospitalMapping.scss";
import HealthemSpinner from "@components/healthemSpinner/healthemSpinner";
import { CanEdit } from '@components/accessLevel'

const PayorCaseManagerListTable = (props: any) => {
  const primaryKey = "payor_name";
  const HOSPITAL_LIST_TAB_NAME = "Payor Case Manager";

  const setIsAddTableRowModalOpen = useHospitalMappingStore((state) => state.setIsAddTableRowModalOpen);
  const currentpageMode = useHospitalMappingStore((state) => state.pageCurrentMode);
  const setModalData = useHospitalMappingStore((state) => state.setModalData);
  const setModalMode = useHospitalMappingStore((state) => state.setModalMode);
  const activeTab = useHospitalMappingStore((state) => state.activeTab);
  const isHospitalListLoading = useHospitalMappingStore((state) => state.isHospitalListLoading);
  const isHospitalListTabColumnConfigLoaded = useHospitalMappingStore((state) => state.isHospitalListTabColumnConfigLoaded);

  useEffect(() => {
    console.log("PayorCaseManagerListTable.useEffect");
    if (tabKeyName.payerCaseManager === activeTab) {
      setModalData({
        title: "Payor Case Manager",
        data: props.data,
        columnData: props.column,
        rowData: [],
      });
      setModalMode("add");
    }
  }, [activeTab, props.column, props.data, setModalData, setModalMode]);

  const softDeleteRow = (record: any) => {
    if (currentpageMode === "edit") {
      let body = {
        facilityName: record.facility_name,
        payorName: record.payor_name,
        payorCaseManagerName: record.hosplst_payor_casemgr_name,
        isDelete: record.is_active === "Y" ? true : false,
      };

      HospitalListCMService.editHospitalMapping(HOSPITAL_LIST_TAB_NAME, body).subscribe({
        next: (v) => {
          let temp = props.data.map((opt: any) => {
            let temp1 = { ...opt };
            if (record[primaryKey] === opt[primaryKey] && record?.hosplst_payor_casemgr_name === opt?.hosplst_payor_casemgr_name) {
              temp1 = {
                ...temp1,
                is_active: record.is_active === "Y" ? "N" : "Y",
              };
            }
            return temp1;
          });
          props.setData(temp);
        },
        error: (e) => {
          console.log(e);
        },
      });
    }
  };

  const rowDataUpdate = (record: any) => {
    props.setData([
      ...props.data.map((payorCaseManager: any) => {
        let tempCaseManager: any = payorCaseManager;
        if (payorCaseManager.payor_name === record.payorName) {
          tempCaseManager = {
            ...tempCaseManager,
            hosplst_payor_casemgr_email_id: record.payorCaseManagerMail,
            hosplst_payor_casemgr_fax_num: record.payorCaseManagerFax,
            hosplst_payor_casemgr_name: record.payorCaseManagerName,
            hosplst_payor_casemgr_phone_num: record.payorCaseManagerPhone,
            payor_name: record.newPayorName,
          };
        }
        return tempCaseManager;
      }),
    ]);
  };

  // const validatePayorCaseManagerName = (inputText:string) => {
  //   let validatedText = true;
  //   forEach( props.data , (payorCaseManager:any) => {
  //     if(payorCaseManager?.payor_name?.trim().toLowerCase() === inputText?.trim()?.toLowerCase())
  //       validatedText = false;
  //   })
  //   return {
  //     validation : validatedText,
  //     error_message : "Payor Case Manager Already Exists.!",
  //   };
  // }

  const Add_new_row = (record: any) => {
    let tempHospitalObject = {
      facility_name: record.facilityName,
      hosplst_payor_casemgr_email_id: record.payorCaseManagerMail,
      hosplst_payor_casemgr_fax_num: record.payorCaseManagerFax,
      hosplst_payor_casemgr_name: record.payorCaseManagerName,
      hosplst_payor_casemgr_phone_num: record.payorCaseManagerPhone,
      payor_name: record.payorName,
      is_active: "Y",
    };
    props.setData([...props.data, tempHospitalObject]);
  };

  return (
    <div>
      {isHospitalListLoading || isHospitalListTabColumnConfigLoaded ? (
        <div className="hospital-cm-report-loader">
          <Spin size="large" className="hospital-cm-report-loader__spinner" indicator={<HealthemSpinner/>}/>
        </div>
      ) : (
        <>
        <div className="HospitalList-And-CM-TableComponent">
          <TableComponent column={props.column} data={props.data} setData={props.setData} primaryKey={primaryKey} tab={HOSPITAL_LIST_TAB_NAME} delete={softDeleteRow} />
          {currentpageMode === "edit" ? (
            <CanEdit>
            <div
              className="HospitalList-And-CM-TableComponent__add-row"
              onClick={() => {
                setIsAddTableRowModalOpen(true);
                setModalMode("add");
              }}
            >
              <div className="HospitalList-And-CM-TableComponent__add-row__icon">
                <Icon name="addFacility" />
              </div>
              <div className="HospitalList-And-CM-TableComponent__add-row__title">Add Payor Case Manager</div>
            </div>
            </CanEdit>
          ) : null}
          </div>
          <HopitalListAddAndUpdateModal data={props.data} setData={props.setPayorCaseManagerListState} updateRow={rowDataUpdate} addRow={Add_new_row} hospitalData={ props.hospitalData } caseManagerData ={ props.caseManagerData } payorCaseManager = {props.payorCaseManager} hospitalSetData={props.hospitalSetData} caseManagerSetData={props.caseManagerSetData} payorCaseManagerSetData={props.payorCaseManagerSetData}/>
        </>
      )}
    </div>
  );
};

export default PayorCaseManagerListTable;
